import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/common/material-module';

@Component({
    selector: 'app-confirm-quote-dialog',
    templateUrl: './confirm-quote-dialog.component.html',
    imports: [MaterialModule]
})
export class ConfirmQuoteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmQuoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { hs_full_name: string }
  ) {}

  confirm() {
    this.dialogRef.close(true);
  }
}
